import React, { useState } from "react";

//ANT DESIGN IMPORTS
import {
  Form,
  Row,
  Select,
  Typography,
  Checkbox,
  Divider,
  Radio,
  Col,
  Popconfirm,
  Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { DownOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import EditableTable from "../EditableTable";
import { labelConfig } from "../../../../customer/customer.config";
import ConfigureFundSource from "./accountingForms/ConfigureFundSource";
import MapFees from "./accountingForms/MapFees";

const { Text, Title } = Typography;

const AccountingForm = (props) => {
  const {
    onFinish,
    initialValues,
    form,
    assetAccountOptions,
    showAdvancedAccounting,
    mapPenaltyTableSource,
    setMapPenaltyTableSource,
    setShowAdvancedAccounting,
    isLoading,
    setIsLoading,
    incomeAccountOptions,
    expenseAccountOptions,
    liabilityAccountOptions,
    paymentTypeOptions,
    userData,
    configureFundTableSource,
    setConfigureFundTableSource,
    fundCount,
    setFundCount,
    charges,
    mapFeeTableSource,
    setMapFeeTableSource,
    feeCount,
    setFeeCount,
    chargeOptions,
    feesOptions,
    feeToIncomeAccountMappingsArr,
    paymentChannelToFundSourceMappingsArr,
    penaltyToIncomeAccountMappingsArr,
  } = props;

  const [dataSource, setDataSource] = useState([
    {
      key: "0",
      paymentType: "Edward King 0",
      fundSource: "32",
    },
  ]);

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const defaultColumns = [
    {
      title: "Payment Type",
      dataIndex: "paymentType",
      width: "30%",
      //   editable: true,
    },
    {
      title: "Fund Source",
      dataIndex: "fundSource",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
            <CloseOutlined
              style={{
                color: "#92428B",
                fontSize: "15px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      <div>
        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.assets}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="savingsReferenceAccountId"
                label={<Text strong> Deposit Reference</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={assetAccountOptions}
                  placeholder={"Please select a value"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.liabilities}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="savingsControlAccountId"
                label={<Text strong>Deposit Control</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={liabilityAccountOptions}
                  placeholder={"Select an Option"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transfersInSuspenseAccountId"
                label={<Text strong>Transfers In Suspense</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={liabilityAccountOptions}
                  placeholder={"Select an Option"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.expenses}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="interestOnSavingsAccountId"
                label={<Text strong>Interest On Deposits</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={expenseAccountOptions}
                  placeholder={"Select an Option"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.income}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="incomeFromFeeAccountId"
                label={<Text strong>Income From Fees</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={incomeAccountOptions}
                  placeholder={"Select an Option"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="incomeFromPenaltyAccountId"
                label={<Text strong>Income From Penalties</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={incomeAccountOptions}
                  placeholder={"Select an Option"}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Title level={4}>
          Advanced Accounting Rule:{" "}
          <span>
            {showAdvancedAccounting ? (
              <>
                <Button
                  type="dashed"
                  onClick={() => setShowAdvancedAccounting(!showAdvancedAccounting)}
                  icon={<DownOutlined />}
                >
                  Hide
                </Button>
              </>
            ) : (
              <>
                <Button
                  type="dashed"
                  onClick={() => setShowAdvancedAccounting(!showAdvancedAccounting)}
                  icon={<RightOutlined />}
                >
                  Show
                </Button>
              </>
            )}
          </span>
        </Title>
        <Divider style={{ margin: 0, padding: 0 }} />
        {showAdvancedAccounting && (
          <div>
            <ConfigureFundSource
              onFinish={onFinish}
              form={form}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              paymentTypeOptions={paymentTypeOptions}
              assetAccountOptions={assetAccountOptions}
              configureFundTableSource={configureFundTableSource}
              setConfigureFundTableSource={setConfigureFundTableSource}
              fundCount={fundCount}
              setFundCount={setFundCount}
            />
            <MapFees
              onFinish={onFinish}
              form={form}
              feesOptions={feesOptions}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              charges={charges}
              incomeAccountOptions={incomeAccountOptions}
              mapFeeTableSource={mapFeeTableSource}
              setMapFeeTableSource={setMapFeeTableSource}
              feeCount={feeCount}
              setFeeCount={setFeeCount}
            />

            {/* <MapPenalties
              onFinish={onFinish}
              form={form}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              penaltyOptions={penaltyOptions}
              incomeAccountOptions={incomeAccountOptions}
              mapPenaltyTableSource={mapPenaltyTableSource}
              setMapPenaltyTableSource={setMapPenaltyTableSource}
              penaltyCount={penaltyCount}
              setPenaltyCount={setPenaltyCount}
            /> */}
          </div>
        )}
      </div>
    </Form>
  );
};

export default AccountingForm;
